import React from "react";
import Modal from "../Modal";
import Button from "../Button";
import styled from "styled-components";
import { Colors } from "../../config";
import { Markup } from "interweave";
import { convertLinks } from "../../helper";

const ErrorSuccessModal = ({
  setClose,
  headerText,
  subheaderText,
  buttonText,
  onButtonClick,
  icon,
}) => {
  return (
    <Modal setClose={setClose}>
      <ErrorSuccessContainer>
        <HeaderSubheader>
          {icon && <img src={icon} style={{ width: "20px", height: "20px" }} />}
          <HeaderText>{headerText}</HeaderText>
          <SubheaderText>
            <Markup content={convertLinks(subheaderText, "here")} />
          </SubheaderText>
        </HeaderSubheader>
        <ButtonWrapper>
          <Button
            label={buttonText}
            bgColor={Colors.red}
            topBottomPadding="0.75rem"
            onClick={onButtonClick}
          />
        </ButtonWrapper>
      </ErrorSuccessContainer>
    </Modal>
  );
};

export default ErrorSuccessModal;

const ErrorSuccessContainer = styled.div`
  padding: 2.625rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;
const HeaderSubheader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.875rem;
`;
const HeaderText = styled.div`
  font-weight: 700;
  font-size: 1.375rem;
  color: ${Colors.brandOne};
  // display: flex;
  // flex-direction: column;
  // gap: 0.5rem;
  // align-items: center;
`;
const SubheaderText = styled.div`
  font-weight: 400;
  font-size: 1.125rem;
  color: ${Colors.shark};
  width: 18.75rem;
  @media only screen and (max-width: 478px) {
    width: 15.625rem;
  }
`;
const ButtonWrapper = styled.div`
  width: 20.375rem;
  @media only screen and (max-width: 478px) {
    width: 15.625rem;
  }
`;
